import { useTranslation } from 'react-i18next'
import { ExchangesKind, ExchangesSettings } from '@/domain/exchanges'
import {
  useResetStoreExchanges,
  useSaveGroupExchanges,
  useSaveStoreExchanges
} from '@/application/manage-exchanges'
import {
  LayeredSettings as GroupLayeredSettings,
  LayeredSettingsProps as GroupLayeredSettingsProps
} from '@/ui/components/group-settings'

export type LayeredSettingsProps<T extends ExchangesSettings> = Omit<
  GroupLayeredSettingsProps<T>,
  'actions' | 'saveAlsoError'
> & { kind: ExchangesKind }

// One kind of exchanges settings for the group, or for one portal of it.
export function LayeredSettings<T extends ExchangesSettings>({
  kind,
  ...props
}: LayeredSettingsProps<T>) {
  const { t } = useTranslation()
  const { saveGroupExchanges, savingGroupExchanges } = useSaveGroupExchanges(
    props.scope.group
  )
  const { saveStoreExchanges, savingStoreExchanges } = useSaveStoreExchanges(
    props.scope.group
  )
  const { resetStoreExchanges, resettingStoreExchanges } =
    useResetStoreExchanges(props.scope.group)
  return (
    <GroupLayeredSettings
      {...props}
      saveAlsoError={t('exchanges.save_error')}
      actions={{
        saveGroup: (value) => saveGroupExchanges({ kind, value }),
        savingGroup: savingGroupExchanges,
        saveStore: (ecommerceId, value) =>
          saveStoreExchanges({ ecommerceId, kind, value }),
        savingStore: savingStoreExchanges,
        resetStore: (ecommerceId, options) =>
          resetStoreExchanges({ ecommerceId, kind }, options),
        resettingStore: resettingStoreExchanges
      }}
    />
  )
}
